import { render, staticRenderFns } from "./ApmsRegFarmingInfo.vue?vue&type=template&id=5b9f9fa1&scoped=true&"
import script from "./ApmsRegFarmingInfo.vue?vue&type=script&lang=js&"
export * from "./ApmsRegFarmingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f9fa1",
  null
  
)

export default component.exports